export default __webpack_public_path__ + "static/about-videos-img-f15c3bc0e30d9031e9cb825b6423c267.png";